import { getInclusiveDates } from 'helpers/date-helper';

export const buildAncillaryApiData = (
  serviceSlots: AncillarySlots,
  startDate: Date,
  endDate: Date,
): AncillarySlotsAPIData => {
  const dates = getInclusiveDates(startDate, endDate);

  return Object.keys(serviceSlots).reduce((acc: AncillarySlotsAPIData, cur) => {
    acc[cur] = dates.map((d) => serviceSlots[cur][d] ?? 0);
    return acc;
  }, {});
};
